// src/layouts/calendar/as-calendar.tsx
import Button from "@a24/ui/Button";
import CalendarTile from "@a24/ui/CalendarTile";
import { format } from "date-fns";
import { useEffect, useState } from "react";
import { useHits } from "react-instantsearch";
import { jsx, jsxs } from "react/jsx-runtime";
var DAY_NAME_OF_WEEK_SHORT = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
var AsCalendar = ({
  className,
  id,
  isPrevButtonDisabled,
  isNextButtonDisabled,
  labels,
  monthYearToDisplay,
  selectPreviousMonth,
  selectNextMonth
}) => {
  const { items } = useHits();
  const [currentDate, setCurrentDate] = useState(/* @__PURE__ */ new Date());
  useEffect(() => {
    setCurrentDate(monthYearToDisplay || /* @__PURE__ */ new Date());
  }, [monthYearToDisplay]);
  const daysOfTheWeek = Array.from(
    { length: 7 },
    (_, i) => DAY_NAME_OF_WEEK_SHORT[i]
  );
  const getDaysInMonth = (date) => {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
  };
  const getFirstDayOfMonth = (date) => {
    return new Date(date.getFullYear(), date.getMonth(), 1).getDay();
  };
  const today = /* @__PURE__ */ new Date();
  const daysInMonth = getDaysInMonth(currentDate);
  const firstDayOfMonth = getFirstDayOfMonth(currentDate);
  const days = [];
  for (let i = 0; i < firstDayOfMonth; i++) {
    days.push(
      /* @__PURE__ */ jsx(
        "div",
        {
          className: "border-[0.5px] bg-heritage-off-white-full border-heritage-off-white-80"
        },
        `empty-start-${i}`
      )
    );
  }
  for (let i = 1; i <= daysInMonth; i++) {
    const tiles = [];
    items.map((item) => {
      const dayMatch = format(item.startDate, "d") === i.toString();
      const monthMatch = format(item.startDate, "MM") === format(currentDate, "MM");
      const yearMatch = format(item.startDate, "yyyy") === format(currentDate, "yyyy");
      if (dayMatch && monthMatch && yearMatch) tiles.push(item);
    });
    let isDisabled = false;
    if (tiles.length > 0) {
      isDisabled = tiles.every((tile) => new Date(tile.startDate) < today);
    }
    days.push(
      /* @__PURE__ */ jsx(
        CalendarTile,
        {
          isDisabled,
          title: i.toString(),
          titlePrefix: i === 1 ? format(currentDate, "MMM") : "",
          items: tiles
        },
        `day-${i.toString()}`
      )
    );
  }
  let fillUntilLastColumn = 0;
  if (6 * 7 > days.length) fillUntilLastColumn = 6 * 7 - days.length;
  if (5 * 7 > days.length) fillUntilLastColumn = 5 * 7 - days.length;
  if (4 * 7 > days.length) fillUntilLastColumn = 4 * 7 - days.length;
  if (fillUntilLastColumn) {
    for (let i = 0; i < fillUntilLastColumn; i++) {
      days.push(
        /* @__PURE__ */ jsx(
          "div",
          {
            className: "border-[0.5px] bg-heritage-off-white-full border-heritage-off-white-80 opacity-[0.5]"
          },
          `empty-end-${i}`
        )
      );
    }
  }
  const goToPreviousMonth = () => {
    setCurrentDate(
      new Date(currentDate.getFullYear(), currentDate.getMonth() - 1)
    );
    selectPreviousMonth();
  };
  const goToNextMonth = () => {
    setCurrentDate(
      new Date(currentDate.getFullYear(), currentDate.getMonth() + 1)
    );
    selectNextMonth();
  };
  return /* @__PURE__ */ jsxs("div", { className, id, children: [
    /* @__PURE__ */ jsx("div", { className: "grid grid-cols-7 grid-rows-1 gap-1", children: daysOfTheWeek.map((day, index) => {
      return /* @__PURE__ */ jsx("p", { className: "body-lg pb-6 pl-2", children: day }, `${index}${day}`);
    }) }),
    /* @__PURE__ */ jsx("div", { className: "grid grid-cols-[repeat(7,1fr)] border-[0.5px] border-heritage-off-white-80 bg-heritage-off-white-full", children: days }),
    /* @__PURE__ */ jsxs("div", { className: "flex justify-between", children: [
      /* @__PURE__ */ jsx(
        Button,
        {
          className: "button-secondary mt-4 disabled:cursor-default",
          disabled: isPrevButtonDisabled,
          label: labels?.previousMonth,
          onClick: goToPreviousMonth
        }
      ),
      /* @__PURE__ */ jsx(
        Button,
        {
          className: "button-secondary mt-4 disabled:cursor-default",
          disabled: isNextButtonDisabled,
          label: labels?.nextMonth,
          onClick: goToNextMonth
        }
      )
    ] })
  ] });
};
var as_calendar_default = AsCalendar;

export {
  as_calendar_default
};
